<fgb-banner [pageTitle]="'games.page.title' | translate" />

<fgb-page-header [pageTitle]="'games.page.title'" [showBalance]="true" [backButtonLink]="'/'" />

<div class="container mobile-content-wrapper px-lg-0">
  <div class="game-container text-white mt-lg-4 d-flex">
    <div class="game-item">
      <img src="assets/images/games/TriviaBanner.png" alt="" />
      <div class="game-info p-3">
        <h6 class="title font-size-20 fw-bold mb-0">{{ 'games.page.trivia.title' | translate }}</h6>
        <p class="description font-size-14">{{ 'games.page.description' | translate }}</p>

        <a [routerLink]="['/games/trivia']" class="font-size-14 fw-bold mb-1">{{ 'games.page.play' | translate }}</a>
      </div>
    </div>
    <div class="game-item">
      <img src="assets/images/games/PollsBanner.png" alt="" />
      <div class="game-info p-3">
        <h6 class="title font-size-20 fw-bold mb-0">{{ 'games.page.polls.title' | translate }}</h6>
        <p class="description font-size-14">{{ 'games.polls.description' | translate }}</p>

        <a [routerLink]="['/games/polls']" class="font-size-14 fw-bold mb-1">{{ 'games.page.vote' | translate }}</a>
      </div>
    </div>
    <!-- <div class="game-item">
      <img src="assets/images/games/PredictorBanner.jpg" alt="" />
      <div class="game-info p-3">
        <h6 class="title font-size-20 fw-bold mb-0">{{ 'games.predictor' | translate }}</h6>
        <p class="description font-size-14">{{ 'games.predictor.description' | translate }}</p>

        <a [routerLink]="['/games/predictor']" class="font-size-14 fw-bold mb-1">{{ 'games.predictor.predict' | translate }}</a>
      </div>
    </div> -->
  </div>
</div>
